import React ,{useState, useCallback, useMemo} from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import SimpleReactValidator from 'simple-react-validator';
import logo from '../images/logo.png';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useNavigate } from "react-router-dom";

var api = require('../Common/Config');
var GET_OTP = 'anonymous/sendOTPToClient?userId='
var FORGOT_PASSWORD= 'anonymous/forgotPassword?userId='

function ForgotPassword () {
        var errrorText = <div/>;
        const [validator,setValidator] = useState(new SimpleReactValidator());
        const[UserName, setUserName] = useState('');
        const[ ConfirmOTP, setConfirmOTP] = useState(false);
        const[ SuccessMsg, setSuccessMsg] = useState(false);
        const[ sentEmail, setSentEmail] = useState("");
        const[ PassUpdateFail, setPassUpdateFail] = useState(false);
        const[ FailMessge, setFailMessge] = useState("");      
        const[ EnteredOTP, setEnteredOTP] = useState("");  
        const[ OtpReference, setOtpReference] = useState("");  
        const[ SentMobile, setSentMobile] = useState("");  
        const[ WrongUser, setWrongUser] = useState("");  
        const[ WrongMsg, setWrongMsg] = useState("");   
        const[ NIC, setNIC] = useState("");   
        const [idType, setIDType] = useState("NIC");
        const navigate = useNavigate();
        var NICValidate = /^([0-9]{9}[X|V]|[0-9]{12})$/m
        let passportValidate = /^(?!^0+$)[a-zA-Z0-9]{3,20}$/gm;
        const GetOTP  = async() =>{                  
        if(idType == 'NIC' && !NICValidate.test(NIC)){            
            setWrongMsg("Invalid NIC Format");
        }else if(idType == 'PAS' && !passportValidate.test(NIC)){
            setWrongMsg("Invalid Passport Number Format");
        }else{
            return await axios({
              url:api.HOST+GET_OTP+UserName.replace(/[^a-zA-Z0-9_]/g, "").replace(/\s+/g, '').toLowerCase(), 
              method: "GET",
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              }
            }).then((result) => {
             
                if(result.data.status=="success"){
                    setConfirmOTP(true);
                    setOtpReference(result.data.otpRef);
                    setSentMobile(result.data.mobileNo);
                    setWrongMsg("");

                }else if (result.data.status=="error"){                   
                    setWrongMsg(result.data.description);                
                }
                return result;
            }).catch((err)=> {
              console.log(err.response.status);             
              setWrongMsg(err.response.data.description);                  
          });
        }
        }

        const handleIDType = (event) => {
            setIDType(event.target.value);
        }
        
        const ResendOTP  = async() =>{ 
            return await axios({
              url:api.HOST+GET_OTP+UserName.replace(/[^a-zA-Z0-9_]/g, "").replace(/\s+/g, '').toLowerCase(), 
              method: "GET",
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              }
            }).then((result) => {             
                if(result.data.status=="success"){                    
                    setOtpReference(result.data.otpRef);
                    setSentMobile(result.data.mobileNo);
                    setWrongMsg("");
                }else if (result.data.status=="error"){                   
                    setWrongMsg(result.data.description);                
                }
                return result;
            }).catch((err)=> {         
              setWrongMsg(err.response.data.description);                  
          });
        }
        
        const ForgotPass = async () =>{
            
            return await axios({
              url:api.HOST+FORGOT_PASSWORD+UserName.replace(/[^a-zA-Z0-9_]/g, "").replace(/\s+/g, '').toLowerCase()+'&otpCode='+EnteredOTP+'&otpRef='+OtpReference+'&nic='+NIC+'&idType='+idType, 
              method: "GET",
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              }
            }).then((result) => {
                if(result.data.status=="SUCCESS"){
                    setConfirmOTP(false);
                    setSuccessMsg(true);
                    setSentEmail(result.data.email);
                    setFailMessge("")                  
                }else if (result.data.status=="UNSUCCESS"){                    
                    setPassUpdateFail(true);
                    setFailMessge(result.data.message);                      
                }
                return result.data;
            }).catch((error)=> {              
              console.log(error);
              setFailMessge(error.result.data.message);
          });
        }
        
       
        
        const OTPModal =  () =>{
                return(
                <Modal  
                    show={ConfirmOTP}             
                    size="sm"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered 
                    backdrop="static"
                    onHide={() => {setConfirmOTP(false);setFailMessge("")}}
                    >
                    <Modal.Header closeButton>
                        <Modal.Title className='hselect' id="contained-modal-title-vcenter">
                        <p className='modal-head-f'>OTP</p><br/> CONFIRMATION
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    
                    <p className='form-h3 form-h2'>We have sent you a OTP code to {SentMobile}. Please enter it below.</p>
                    <Form className="text-center" onSubmit={e => e.preventDefault()}>
                        <div className="form-group">
                        <Form.Control type="text" 
                        onChange={(e)=>setEnteredOTP(e.target.value)}
                        placeholder="OTP Code" /> 
                        <p className="error-text2">{FailMessge} </p>                      
                        </div>                        
                        <div className="d-flex justify-content-end">                        
                        <Button type="button" onClick={()=>ResendOTP()} className="btn-logout"  >Resend OTP</Button>
                        <Button type="button"  onClick={()=>ForgotPass()} className="btn-logout " >Confirm</Button>
                        </div>
                    </Form>                                           
                    </Modal.Body>
                    </Modal>
                );
        }

            return(
                <Container fluid className='body-register'>
                    <Container>
                        {OTPModal()}
                        <Row>
                            {SuccessMsg?
                            <SweetAlert success btnSize='lg' confirmBtnBsStyle='success' title="Done!" onConfirm={()=> setSuccessMsg(false)} >
                            Temporary Password sent to your mail {sentEmail}
                            </SweetAlert>
                            :null}
                        </Row>
                        <Row>
                            <Col lg={4}>
                            <div className="login-area block-top bottoms ">
                                <img className='logo' alt="Senfin" src={logo} />
                                <div>
                                <h3>SENFIN ONLINE PORTAL </h3>   
                                <p className='small-font-log'>MAKE YOUR DIGITAL TRANSACTIONS THE SIMPLE WAY</p>                     
                                </div>                        
                            </div>
                            </Col>               
                        </Row>
                        <Row className='flex-row-center mt-4'>
                        <Col lg={12} sm={12}>
                        <div className="main-wrap2 animate__animated animate__fadeIn animate__faster ">
                            <div  className="column-inner bottoms" style={{width:'450px'}}>
                                <div className="login-area bottoms ">
                                    <div>
                                    <h4>REQUEST NEW PASSWORD</h4>                        
                                    </div>                        
                                </div>
                                
                                <Form style={{width:'100%'}} onSubmit={e => e.preventDefault()}>
                                <Form.Group as={Row} className="mb-1 margintop-f">
                                    <Form.Label className="c-font" column lg={4} sm={12}>
                                        Username
                                    </Form.Label>
                                    <Col lg={8} sm={12} >
                                    <input                             
                                    value={UserName.replace(/[^a-zA-Z0-9_]/g, "").replace(/\s+/g, '').toLowerCase()}
                                    onChange ={(e)=>setUserName(e.target.value)} 
                                    className="l-input2"
                                    size="sm" type="text" placeholder="Username" />
                                    <p className='vali-txt'>{validator.message('Username', UserName, 'required')}</p>
                                    </Col>
                                    
                                </Form.Group>
                                <Form.Group as={Row} className="mb-1 margintop-f">
                                <Form.Label className="c-font " column sm={4}>
                                    Identification Type
                                </Form.Label>
                                <Col sm={8}>
                                <Form.Select size="sm" className="form-h2 " value={idType} onChange={handleIDType} >
                                        <option value="">- SELECT -</option>
                                        <option value="NIC">National ID No</option>
                                        <option value="PAS">Passport No</option>
                                        <option value="BRG">Business Registration No</option>
                                    </Form.Select>
                                    <p className='vali-txt'>{validator.message('idType', idType, 'required')}</p>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-1 margintop-f">
                                    <Form.Label className="c-font" column lg={4} sm={12}>
                                    Identification No
                                    </Form.Label>
                                    <Col lg={8} sm={12} >
                                    <input 
                                    
                                    maxLength={16}
                                    value={NIC}
                                    onChange ={(e)=>setNIC(e.target.value)} className="l-input2" size="sm" type="text" placeholder={idType == 'NIC'?'National ID No':(idType=="PAS"?'Passport No':'Business Registration No')} />
                                    <p className='vali-txt'>{validator.message('NIC', NIC, 'required')}</p>
                                    <p className="error-text">{WrongMsg}</p>
                                    </Col>                           
                                </Form.Group>

                                <Form.Group as={Row}  className="mb-1" >
                                <Col sm={12} className="c-space-between">                  
                                    <Button
                                    className="btn-login s-bottoms"
                                        variant="primary" size="sm"
                                        onClick={() => navigate('/')} >
                                        BACK
                                    </Button>
                                    <Button onClick={()=>GetOTP()} 
                                    className="btn-login s-bottoms"
                                    vvariant="primary" size="sm"
                                     type="submit">
                                        CONTINUE
                                    </Button>
                                </Col>                       
                                </Form.Group>    
                                </Form>
                            </div>
                        </div>
                        </Col>
                        </Row>
                    </Container>
                </Container>
            )
    
}
export default ForgotPassword;